import { api } from '@/lib/api';
import type {
  IApiResponse,
  IPortfolioCodeQualityByTeam,
  IPortfolioCodeQualityDistribution,
  IPortfolioCodeQualitySummary,
  IPortfolioCodeQualityTrend,
} from '@skystone/shared';

export interface ICodeQualityQueryParams {
  from: string;
  to: string;
  productId?: string;
  teamId?: string;
}

function buildQuery(params: ICodeQualityQueryParams): string {
  const search = new URLSearchParams({ from: params.from, to: params.to });
  if (params.productId) search.set('productId', params.productId);
  if (params.teamId) search.set('teamId', params.teamId);
  return `?${search.toString()}`;
}

export const portfolioCodeQualityApi = {
  getSummary: async (params: ICodeQualityQueryParams): Promise<IPortfolioCodeQualitySummary> => {
    const result = await api.get<IApiResponse<IPortfolioCodeQualitySummary>>(
      `/portfolio/code-quality-summary${buildQuery(params)}`,
    );
    return result.data;
  },

  getTrend: async (params: ICodeQualityQueryParams): Promise<IPortfolioCodeQualityTrend> => {
    const result = await api.get<IApiResponse<IPortfolioCodeQualityTrend>>(
      `/portfolio/code-quality-trend${buildQuery(params)}`,
    );
    return result.data;
  },

  getDistribution: async (params: ICodeQualityQueryParams): Promise<IPortfolioCodeQualityDistribution> => {
    const result = await api.get<IApiResponse<IPortfolioCodeQualityDistribution>>(
      `/portfolio/code-quality-distribution${buildQuery(params)}`,
    );
    return result.data;
  },

  getByTeam: async (params: ICodeQualityQueryParams): Promise<IPortfolioCodeQualityByTeam> => {
    const result = await api.get<IApiResponse<IPortfolioCodeQualityByTeam>>(
      `/portfolio/code-quality-by-team${buildQuery(params)}`,
    );
    return result.data;
  },
};
